<template>
	<div class="py-20 md:py-0">
		<div class="bg-ihh-white p-12 text-center text-4xl w-full justify-center flex">
			<div class="text-ihh-midnight-gray font-medium">Frequently Asked Questions</div>
			<!-- <div class="absolute -translate-y-[2px] -translate-x-[2px] px-12 text-ihh-salmon font-bold">Frequently Asked Questions</div> -->
		</div>

		<div class="flex w-full justify-center pb-20">
			<div class="flex flex-col w-full jusify-center max-w-xl lg:max-w-5xl space-y-4">
				<details v-for="aq in faqs" :key="aq" class="cursor-pointer rounded-lg w-full bg-ihh-dark-salmon border border-ihh-dark-salmon">
					<summary class="flex p-4">
						<p class="text-ihh-white font-semibold text-base">{{ aq.question }}</p>
					</summary>
					<div class="bg-ihh-white rounded-b-lg text-ihh-midnight-gray text-base p-4">
						<p v-safe-html="aq.answer"></p>
					</div>
				</details>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'FAQS',
	data() {
		return {
			faqs: [
				{
					question: "Why is my midwife's birth kit a different price than what she told me or what is on her order form?",
					answer: `<div>
						<div>There could be a few reasons for this happening:</div>
						<div>
							<ul class="bullet-list">
								<li>The birth kit price on our website doesn’t include any shipping cost; the price you were given may have included shipping.</li>
								<li>
									Your midwife may have modified her kit content with In His Hands, therefore changing the price. These changes may not be reflected in the
									price that you have.
								</li>
								<li>Price increases are occasionally necessary and may cause the custom birth kit price to be different.</li>
								<li>
									The InHisHands.com price is the correct price of what we have on file for your midwife. You will be sent the most up-to-date version of
									your midwife's custom birth kit and not charged any more than the price reflected on InHisHands.com.
								</li>
							</ul>
						</div>
					</div>`,
				},
				{
					question: 'If I am allergic to latex, what should I do?',
					answer: '<p>If you are allergic to latex, just let us know in the comments section of your order when you checkout. We will check your order for products (mainly gloves) containing latex and happily exchange them for latex-free alternatives at no extra charge.</p>',
				},
				{
					question: 'How do I order the birth kit if I don’t want everything in the kit?',
					answer: '<p>Our website allows you to make individual changes to your birth kit before adding it to your cart.</p>',
				},
				{
					question: 'How can I find out what is in my midwife’s custom birth kit prior to ordering it?',
					answer: `<p>You can search for your midwife's kit <a href="/midwife-birth-kits" class="underline" target="_blank" rel="noopener noreferrer">here</a> for a list of the items contained in it.</p>`,
				},
				{
					question: 'Do the herbal sitz baths expire?',
					answer: '<p>They do not. As long as the baths are kept sealed in a cool, dry place they should last a long time.</p>',
				},
				{
					question: 'Can I use my HSA card on your website?',
					answer: '<p>Yes! HSA cards do work on Inhishands.com. Please contact us if you have trouble paying for your order with your health savings card.</p>',
				},
				{
					question: 'What items require a healthcare license to purchase?',
					answer: '<p>Fetal dopplers, Hemocue 801 Hemoglobin Meter, Masimo Rad-G Pulse Oximeter and all IV Fluids. You can enter licensure information in the notes section at checkout.</p>',
				},
				{
					question: 'Are there bulk discounts available?',
					answer: `<p>Yes! Many items are available at a discount in bulk. View many of those items <a href="/categories/bulk-items" class="underline" target="_blank" rel="noopener noreferrer">here</a>. Looking for something else in particular? Please contact us!</p>`,
				},
				{
					question: 'How long will it take my order to arrive?',
					answer: `<p>Depending on the shipping option you chose, your order will take 1-7 business days to arrive. International orders may take longer.</p>`,
				},
				{
					question: 'Will I automatically be sent a tracking number for my shipment?',
					answer: `<p>Yes, you will be sent a tracking link once your order ships. If you have not received a tracking link, please <a href="/help-center" class="underline" target="_blank" rel="noopener noreferrer">contact us</a>.</p>`,
				},
				{
					question: 'How do I return items?',
					answer: `<p>You can start your return and see our complete return policy <a href="/returns" class="underline" target="_blank" rel="noopener noreferrer">here</a>.</p>`,
				},
				{
					question: "I have received my order and it isn't correct, what should I do?",
					answer: `<p>Please double-check and unpack the entire box to ensure that a mistake has been made, then please <a href="/help-center" class="underline" target="_blank" rel="noopener noreferrer">contact us</a> with the following information:</p>
					<ul class="bullet-list">
						<li>Your order number</li>
						<li>Description of missing item(s)</li>
						<li>Quantity of missing item(s)</li>
						<li>Your contact information</li>
					</ul>
					<p>We will check into the issue and contact you with a solution.</p>`,
				},
				{
					question: 'I am a midwife; how do I set up a Custom Birth Kit with In His Hands?',
					answer: `<p>Thank you for your interest! You can fill out <a href="/new-birth-kit-setup" class="underline" target="_blank" rel="noopener noreferrer">this form</a> to set up your kit.</p>`,
				},
				{
					question: 'What are your rules regarding coupon codes, sales, and promotions?',
					answer: `<p>You can view rules regarding coupon codes <a href="/discount-code-terms" class="underline" target="_blank" rel="noopener noreferrer">here</a>.</p>`,
				},
				{
					question: 'What is your privacy policy?',
					answer: `<p>You can view our privacy policy <a href="/privacy-policy" class="underline" target="_blank" rel="noopener noreferrer">here</a>.</p>`,
				},
				{
					question: 'What are your Terms and Conditions?',
					answer: `<p>You can view our terms and conditions <a href="/terms-and-conditions" class="underline" target="_blank" rel="noopener noreferrer">here</a>.</p>`,
				},
			],
		}
	},
	methods: {},
}
</script>

<style scoped>
/* Global styles for FAQ content */
.bg-ihh-white ul {
	list-style-type: disc !important;
	margin-left: 20px;
	padding-left: 15px;
	margin-top: 16px;
}

.bg-ihh-white li {
	display: list-item !important;
	margin-bottom: 8px;
}

a {
	@apply underline;
	@apply text-ihh-dark-salmon;
}
</style>
